import { render, staticRenderFns } from "./energy.vue?vue&type=template&id=54f4c59a&scoped=true"
import script from "./energy.vue?vue&type=script&lang=js"
export * from "./energy.vue?vue&type=script&lang=js"
import style0 from "./energy.vue?vue&type=style&index=0&id=54f4c59a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f4c59a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54f4c59a')) {
      api.createRecord('54f4c59a', component.options)
    } else {
      api.reload('54f4c59a', component.options)
    }
    module.hot.accept("./energy.vue?vue&type=template&id=54f4c59a&scoped=true", function () {
      api.rerender('54f4c59a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home-page/compontents-cool/energy.vue"
export default component.exports